/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "203b20c87ed39de0f427501e75bad710d5bd8b0f";
